/*
 * ActiveCampaign signup — one shared helper for every form on the site that sends
 * an address to ActiveCampaign (guide downloads, the promo popup).
 *
 * Posts to the account's hosted-form endpoint the same way ActiveCampaign's current
 * embed code does: a POST of the form fields to proc.php?jsonp=true, answered with
 * JSON ({ action: 'show_thank_you' | 'show_error', data: { message } }). No API key
 * reaches the browser — form IDs are public — and the form's list subscription and
 * tag actions fire exactly as for an embedded form, which is what starts
 * tag-triggered automations. The endpoint allows cross-origin requests.
 *
 * The older GET/JSONP variant is not used: current forms reject it.
 *
 *   window.LAActiveCampaign.subscribe(account, formId, email)
 *     resolves                          ActiveCampaign accepted the address
 *     rejects { fromAC: true, message } ActiveCampaign refused it (bad address,
 *                                       misconfigured form) — show the message
 *     rejects { fromAC: false }         no answer (blocked, offline, timeout)
 */
(function () {
  'use strict';
  if (window.LAActiveCampaign) return;

  var TIMEOUT_MS = 8000;

  function subscribe(account, formId, email) {
    return new Promise(function (resolve, reject) {
      if (!account || !formId || !window.fetch) { reject({ fromAC: false }); return; }

      var body = new FormData();
      [['u', formId], ['f', formId], ['s', ''], ['c', '0'], ['m', '0'],
       ['act', 'sub'], ['v', '2'], ['email', email]].forEach(function (p) { body.append(p[0], p[1]); });

      var settled = false;
      var timer = setTimeout(function () { finish(false, { fromAC: false }); }, TIMEOUT_MS);
      function finish(ok, err) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (ok) resolve(); else reject(err);
      }

      fetch('https://' + encodeURIComponent(account) + '.activehosted.com/proc.php?jsonp=true', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body,
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var action = data && data.action;
          if (action === 'show_thank_you' || action === 'show_unsubscribe') {
            finish(true);
          } else {
            finish(false, { fromAC: true, message: data && data.data && data.data.message });
          }
        })
        .catch(function () { finish(false, { fromAC: false }); });
    });
  }

  /*
   * Fallback for when the ActiveCampaign request never gets an answer — almost
   * always an ad blocker, which blocks activehosted.com but not the store's own
   * domain. The address is saved as a Shopify customer tagged `ac-form-<id>`; the
   * Shopify Flow workflow "Blocked signups → ActiveCampaign" watches for that tag
   * and submits the same ActiveCampaign form from Shopify's servers, so the
   * form's tag and automation still fire.
   *
   * Resolves true when Shopify recorded the signup, false when it refused the
   * background post (Shopify's spam protection) or the request failed.
   */
  function saveToShopify(email, formId, extraTags) {
    var tags = (extraTags || []).concat(formId ? ['ac-form-' + formId] : [])
      .map(function (t) { return String(t).trim(); }).filter(Boolean).join(',');
    var body = new FormData();
    body.append('form_type', 'customer');
    body.append('utf8', '\u2713');
    body.append('contact[email]', email);
    body.append('contact[tags]', tags);
    return fetch('/contact', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (r) { return !!(r.url && r.url.indexOf('customer_posted=true') !== -1); })
      .catch(function () { return false; });
  }

  window.LAActiveCampaign = { subscribe: subscribe, saveToShopify: saveToShopify };
})();
